import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function MoneyBagIcon({ className, size = 20, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M8.76037 5.28157L8.88589 5.35689C9.16902 5.52678 9.96822 5.80737 11.0683 5.88959C12.1353 5.96933 13.4121 5.85588 14.6669 5.32665C14.8604 5.21732 15.0886 5.09732 15.3414 4.97538L15.9998 3L13.9997 4L11.9998 3L10 4L7.99984 3L8.76037 5.28157Z"
        fill="currentColor"
      />
      <path
        d="M11.2798 12.272C10.9031 12.3696 10.625 12.7119 10.625 13.119C10.625 13.5262 10.9031 13.8684 11.2798 13.9661V12.272Z"
        fill="currentColor"
      />
      <path
        d="M12.5298 16.9936C12.9992 16.9779 13.375 16.5923 13.375 16.119C13.375 15.6458 12.9992 15.2602 12.5298 15.2445V16.9936Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8472 6.39806C15.6704 6.48644 15.51 6.57238 15.3721 6.6512C15.3473 6.66537 15.3217 6.67812 15.2954 6.68937C13.7622 7.34643 12.2205 7.47988 10.9565 7.38542C9.715 7.29263 8.66426 6.97322 8.11411 6.64311L7.92611 6.5303C2.31456 9.95204 1.16048 21.5287 11.9998 22C22.9835 21.5224 21.6523 9.64192 15.8472 6.39806ZM11.9048 10.375C12.2499 10.375 12.5298 10.6548 12.5298 11V11.0066C13.707 11.1287 14.625 12.1238 14.625 13.3333C14.625 13.6785 14.3452 13.9583 14 13.9583C13.6548 13.9583 13.375 13.6785 13.375 13.3333C13.375 12.8156 13.0139 12.3823 12.5298 12.2715V13.9943C13.6896 14.0102 14.625 14.9554 14.625 16.119C14.625 17.2827 13.6896 18.2279 12.5297 18.2438C12.5266 18.5864 12.248 18.8631 11.9048 18.8631C11.5596 18.8631 11.2798 18.5833 11.2798 18.2381V18.2038C10.1954 18.0001 9.375 17.0482 9.375 15.9048C9.375 15.5596 9.65482 15.2798 10 15.2798C10.3452 15.2798 10.625 15.5596 10.625 15.9048C10.625 16.3519 10.8944 16.7361 11.2798 16.9039V15.2328C10.2096 15.1226 9.375 14.2183 9.375 13.119C9.375 12.0198 10.2096 11.1155 11.2798 11.0053V11C11.2798 10.6548 11.5596 10.375 11.9048 10.375Z"
        fill="currentColor"
      />
      <path
        d="M16.7757 5.9831C17.3568 5.75337 17.9646 5.57026 18.4995 5.50266C19.0576 5.43213 19.404 5.50393 19.5842 5.62405C19.9288 5.85381 20.3944 5.76068 20.6242 5.41603C20.854 5.07139 20.7608 4.60574 20.4162 4.37597C19.7858 3.95568 18.9945 3.92818 18.3114 4.0145C17.6051 4.10375 16.868 4.33365 16.2243 4.58815C15.8391 4.74043 15.6502 5.17615 15.8025 5.56135C15.9548 5.94656 16.3905 6.13538 16.7757 5.9831Z"
        fill="currentColor"
      />
    </svg>
  )
}
